import PropTypes from "prop-types"
import React, { useMemo, useState } from "react"

import { connect, useSelector } from "react-redux"
// import { Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import lightMednetLogo from "assets/images/logos/mednet_logo_customer_portal.png"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import ShortcutMenu from "./ShortcutMenu"
import TopSearchbar from "./TopSearchbar"
import { claimId } from "utils/modulesIds"
import CustomerLogo from "./CustomerLogo"
import { getMainCustomer, isCustomerUser } from "utils"
import SwitchAccountDropdown from "./SwitchAccountDropdown"

const Header = (props) => {
  const [search, setsearch] = useState(false)

  const { modules } = useSelector((state) => ({
    modules: state.Sidebar.modules,
  }))

  const { customerLogo, isUserCustomer } = useMemo(() => {
    const mainCustomer = getMainCustomer()
    const isUserCustomer = isCustomerUser()
    const mainCustomerLogo = mainCustomer?.logo
    return { customerLogo: mainCustomerLogo, isUserCustomer }
  }, [])

  // Full Screen Togller Functionality

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          {/* Skote Logos (Dark & Light) */}

          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={lightMednetLogo} alt="mednet logo" height="35" />
                </span>
              </Link>
            </div>

            {/* Search bar */}
            {/* it will be shown if the logged in use has a permission of claim page group */}
            {modules.findIndex((module) => module.id === claimId) > -1 ? (
              <TopSearchbar />
            ) : null}
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Customer Logo */}
            {customerLogo ? <CustomerLogo /> : null}

            {/* Switch Account */}

            {isUserCustomer ? <SwitchAccountDropdown /> : null}

            {/* ShortCut Menu */}
            <ShortcutMenu />

            {/* Full Screen Togller Button */}

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
